module.exports = __webpack_public_path__ + "img/Logo-small-trans_new.ad51f03f.png";